/* Cart drawer "Complete the look" quick add */
(function () {
  if (window.__ccLookInit) return;
  window.__ccLookInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cc-look__add');
    if (!button) return;
    var form = button.closest('[data-cc-look-form]');
    if (!form) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    var error = form.parentElement.querySelector('.cc-look__error');
    var idField = form.querySelector('[data-cc-look-id]');
    if (error) error.textContent = '';
    if (!idField || !idField.value) {
      if (error) error.textContent = 'Please choose a size';
      return;
    }

    var cart = document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', idField.value);
    formData.append('quantity', 1);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
    }

    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Adding…';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (error) error.textContent = response.description || response.message || 'Could not add this item';
          button.removeAttribute('aria-disabled');
          button.textContent = 'Add';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-complete-look', productVariantId: idField.value });
        }
        document.dispatchEvent(new CustomEvent('cart:change', { detail: response, bubbles: true }));
        if (cart && response.sections) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        if (error) error.textContent = 'Something went wrong, please try again';
        button.removeAttribute('aria-disabled');
        button.textContent = 'Add';
      });
  });
})();
